
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/our-social-impact",
      function () {
        return require("private-next-pages/about-us/our-social-impact/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/our-social-impact"])
      });
    }
  